import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { POINT_OPACITY_BY_ZOOM } from './useConfigureMapLayers'

const MODEL_LAYER_PREFIX = 'trees-3d-'

/**
 * Modo "solo puntos": cuando está activo, oculta todos los modelos 3D y deja
 * los puntos a 100% de opacidad para comparar verificados (azul) vs no
 * verificados (carmesí). Único escritor de la visibilidad de los modelos 3D
 * y de la opacidad del punto en este modo.
 *
 * `layersReady` como dependencia reaplica el estado tras recargas de estilo.
 */
export const usePointsOnlyMode = (map, layersReady) => {
  const pointsOnlyMode = useSelector(state => state.mapState.pointsOnlyMode)

  useEffect(() => {
    if (!map || !layersReady) return

    const active = Boolean(pointsOnlyMode)

    try {
      // Puntos: 100% opacos en modo plano; fade normal por zoom fuera de él
      if (map.getLayer('unclustered-point')) {
        map.setPaintProperty(
          'unclustered-point',
          'circle-opacity',
          active ? 1 : POINT_OPACITY_BY_ZOOM,
        )
      }

      // Modelos 3D: ocultar todos en modo plano (visibility none = costo ~0)
      const layers = map.getStyle()?.layers || []
      layers.forEach(layer => {
        if (
          layer?.type === 'model' &&
          layer?.id?.startsWith(MODEL_LAYER_PREFIX) &&
          map.getLayer(layer.id)
        ) {
          map.setLayoutProperty(layer.id, 'visibility', active ? 'none' : 'visible')
        }
      })
    } catch (error) {
      console.error('[usePointsOnlyMode] Error:', error)
    }
  }, [map, layersReady, pointsOnlyMode])
}

export default usePointsOnlyMode
